<!-- ADR-0014: mientras el usuario interno deba cambiar su contraseña temporal, se
     oculta el shell (header + leftnav) y se renderiza solo la pantalla bloqueante,
     igual que el login. Sin esto, /change-password aparecía dentro del shell con el
     sidebar accesible. Al limpiar el flag (tras el cambio) vuelve el shell normal. -->
<ng-container *ngIf="authService.getUser && !authService.mustChangePassword;else elseLogin">
  <section class="{{showLeftMenu ? '': 'hideMenu'}}">
    <header>
      <app-skeleton-header (onChangeMenu)="showLeftMenu = !showLeftMenu"></app-skeleton-header>
    </header>
    <nav *ngIf="showLeftMenu">
      <app-skeleton-leftnav></app-skeleton-leftnav>
    </nav>
    <main>
      <router-outlet></router-outlet>
      <app-skeleton-footer></app-skeleton-footer>
    </main>
  </section>
  <!-- Reportar un problema. Va DENTRO del ng-container (solo con sesión iniciada y la contraseña ya
       cambiada) y FUERA del <section>, para no participar de su CSS Grid: es posición fija. -->
  <app-bug-report-launcher></app-bug-report-launcher>
</ng-container>
<ng-template #elseLogin>
  <router-outlet></router-outlet>
</ng-template>
